import { AmplifyModules } from 'aws-amplify-angular';
import Auth from '@aws-amplify/auth';
import Storage from '@aws-amplify/storage';
import API from "@aws-amplify/api";
const toastOptions = {
    autoDismiss: true,
    closeButton: true,
    newestOnTop: false,
    positionClass: 'toast-bottom-right'
};
const ɵ0 = () => {
    return AmplifyModules({
        Auth,
        API,
        Storage,
    });
};
export class AppModule {
}
export { ɵ0 };
